import React, { useState } from "react";
import InventoriesList from "../../components/Inventories/InventoriesList";
import InventoriesModal from "../../components/Inventories/InventoriesModal";
import FilterButton from "../../components/Common/FilterButton";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as InventoriesActions from "../../store/actions/Inventories";

const Inventories = ({ inventoriesList, activeFilters }) => {
  const [modalState, setModalState] = useState("");
  const filterFields = ["geo_id", "start_time"];
  const handleClick = (type) => {
    setModalState(type);
  };

  const handleClose = () => {
    setModalState("");
  };

  return (
    <div className="Inventories-View">
      <div
        style={{ maxWidth: "320px" }}
        className="actionBar mb-20 flex items-end justify-end"
      >
        <FilterButton
          activeFilters={activeFilters}
          handleClick={() => handleClick("Filter")}
        />
      </div>
      <InventoriesList inventoriesList={inventoriesList} />
      {modalState && (
        <InventoriesModal
          modalState={modalState}
          handleClose={handleClose}
          filterFields={filterFields}
        />
      )}
    </div>
  );
};

function mapStateToProps(state) {
  const { Inventories } = state;
  return {
    inventoriesList: Inventories.inventoriesList,
    activeFilters: Inventories.activeFilters,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getInventoriesList: bindActionCreators(
      InventoriesActions.getInventoriesList,
      dispatch
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Inventories);
